import React, { useState } from 'react';
import './AccountStatementModal.css';
import { CommonModal } from 'components';
import { StorageServices } from 'utils';
import { getPaynowStatementDownlaod } from '_services';

const AccountStatementModal = (props) => {
  const { closeModal, onDownload ,accountDetails} = props;
  const [selectedAccount, setSelectedAccount] = useState(accountDetails?.number);
  const [selectedPeriod, setSelectedPeriod] = useState('previous-day');
  const [selectedFormat, setSelectedFormat] = useState('pdf');
  const firmId = StorageServices.getFirmId();
  const [isLoading, setIsLoading] = useState(false)

  const formatDate = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  };

  const getDateRange = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    switch (selectedPeriod) {
      case 'previous-day': {
        const prevDay = new Date(today);
        prevDay.setDate(today.getDate() - 1);
        return { start_date: formatDate(prevDay), end_date: formatDate(prevDay) };
      }
      case 'previous-7-days': {
        const sevenDaysAgo = new Date(today);
        sevenDaysAgo.setDate(today.getDate() - 7);
        return { start_date: formatDate(sevenDaysAgo), end_date: formatDate(today) };
      }
      case 'current-month': {
        const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
        return { start_date: formatDate(firstDay), end_date: formatDate(today) };
      }
      case 'last-90-days': {
        const ninetyDaysAgo = new Date(today);
        ninetyDaysAgo.setDate(today.getDate() - 90);
        return { start_date: formatDate(ninetyDaysAgo), end_date: formatDate(today) };
      }
      default:
        return { start_date: '', end_date: '' };
    }
  };

  const handleDownload = async () => {
    const { start_date, end_date } = getDateRange();
    const payload = {
      firm_id: firmId,
      start_date,
      end_date,
      is_web: false,
    };

    try {
      setIsLoading(true)
      const res = await getPaynowStatementDownlaod(payload);
      if (res) {
        setIsLoading(false)
        onDownload()
      } else {
        setIsLoading(false)
      }
    } catch (error) {
      setIsLoading(false)
    }
    closeModal();
  };

  const propsModalInhance = {
    ...props,
    title: 'Download Account Statement',
    onSubmit: handleDownload,
    modalMainClass: 'addbalance',
    onClose: closeModal,
    submitTitle: isLoading ? "Downloading..." : " Download Statement",
  };

  return (
    <CommonModal {...propsModalInhance}>
      <div className="addLr_body">
        <div className="acst-modal-body">

          {/* Account Selection */}
          <div className="acst-form-group">
            <label className="acst-form-label">SELECTED ACCOUNT</label>
            <div className="acst-select-wrapper">
              <input
                className="acst-form-select"
                value={selectedAccount}
                disabled
                // onChange={(e) => setSelectedAccount(e.target.value)}
              >
              </input>
            </div>
            <p className="acst-account-name">FRESHTIO SOLUTIONS PRIVATE LIMITED</p>
          </div>

          {/* Period Selection */}
          <div className="acst-form-group">
            <label className="acst-form-label">SELECT PERIOD</label>
            <div className="acst-radio-group" style={{ marginBottom: 25 }}>
              {[
                { value: 'previous-day', label: 'Previous day' },
                { value: 'previous-7-days', label: 'Previous 7 days' },
                { value: 'current-month', label: 'Current month' },
                { value: 'last-90-days', label: 'Last 90 days' },
              ].map(({ value, label }) => (
                <label className="acst-radio-label" key={value}>
                  <input
                    type="radio"
                    name="period"
                    value={value}
                    checked={selectedPeriod === value}
                    onChange={(e) => setSelectedPeriod(e.target.value)}
                  />
                  <span className="acst-radio-text">{label}</span>
                </label>
              ))}
            </div>

            {/* File Format Selection */}
            <div className="acst-form-group">
              <label className="acst-form-label">SELECT FILE FORMAT</label>
              <div className="acst-radio-group acst-radio-inline">
                {['pdf'].map((fmt) => (
                  <label className="acst-radio-label" key={fmt}>
                    <input
                      type="radio"
                      name="format"
                      value={fmt}
                      checked={selectedFormat === fmt}
                      onChange={(e) => setSelectedFormat(e.target.value)}
                    />
                    <span className="acst-radio-text">{fmt.toUpperCase()}</span>
                  </label>
                ))}
              </div>
            </div>
          </div>

          {/* Info Text */}
          <p className="acst-info-text">
            You can only download statement for maximum 3 months up to 1 lakh transactions
          </p>
        </div>
      </div>
    </CommonModal>
  );
};

export default AccountStatementModal;